
{
  "fr": {
    "configuratorProductList": {
      "noItem": "Il n'y a pas de thèmes disponibles pour cette configuration (contenance/type d'impression)."
    }
  }
}
